import { Routes } from '@angular/router';
import { AuthGuard } from '../auth.guard';

export const monitorOverviewRoutes: Routes = [
    {
        path: 'monitor/overview',
        loadComponent: () => import('./monitor-overview.component').then(m => m.MonitorOverviewComponent),
        canActivate: [AuthGuard],
        children: [
            {
                path:'',
                canActivate: [AuthGuard],
                loadComponent: () => import('./overview-dashboard/overview-dashboard.component').then(m => m.OverviewDashboardComponent)
            },
            {
                path:'setting',
                canActivate: [AuthGuard],
                loadComponent: () => import('./overview-dashboard-setting/overview-dashboard-setting.component').then(m => m.MonitorOverviewDashboardSettingComponent)
            },
            {
                path:'change-password',
                canActivate: [AuthGuard],
                loadComponent: () => import('../monitor/user/change-password/change-password.component').then(m => m.MonitorChangePasswordComponent)
            }
        ]
    }
];
